import Vue from 'vue'

let vms = []

export function closeAllOverlay() {
  vms.forEach(vm=>{
    vm.$emit('close')
  })
  vms.length = 0
}

export function createPopup(PopupComp, props, option = {}) {
  const { closeName = 'close', ...opts } = option
  let Ctor = Vue.extend(PopupComp)
  let vm = new Ctor({
    el: document.createElement('div'),
    propsData: props || {},
    ...opts
  })

  vm.$on(closeName, () => {
    document.body.removeChild(vm.$el)
    vm.$destroy()
  })

  document.body.append(vm.$el)
  vms.push(vm)
  return vm
}
